// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__qCIKy","loaderWhite":"Loading_loaderWhite__6+C1A","loader-white":"Loading_loader-white__rC+ih"};